import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory, useParams } from "react-router-dom";
import { useData } from "../../DataContext";
import { Helmet } from "react-helmet";

import './IASDirectLoginV2.scss'
import { iAMSmartToken } from '../../components/iAMSmart/iAMSmartHelper';

import Scroll from 'react-scroll';


export default withTranslation()(function IASDirectLoginV2({t, i18n}) {
    let scroll = Scroll.animateScroll;
    const { setValues, data } = useData();
    const history = useHistory();
    const { lang } = useParams();


    useEffect(() => {
        console.log("iAmSmart direct login v2: " + process.env.REACT_APP_IAMSMART_DOMAIN)

        iAMSmartToken(getAuthCode(), true)
        .then((access)=>{
            if("D00000" === access?.code){
                sessionStorage.setItem("directLogin", JSON.stringify(access));
            }else{
                sessionStorage.removeItem("directLogin");
            }
            setTimeout(()=>{history.push(process.env.REACT_APP_SUB_ROUTE + "/" + lang)}, 1000);
        });
    }, [])

    const getAuthCode = () => {
    	const queryString = window.location.search;
    	const urlParams = new URLSearchParams(queryString);
    	const code = urlParams.get('code')
    	return code;
    }

    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    console.log("<><><><>Host:", window.location.hostname.split('.')[0]);
    console.log("<><><><>IP:", window.location.origin);
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-003'}</title>
            </Helmet>
            <div id="loading-wrapper">
                <div id="loading-anime"></div>
            </div>
        </main>
    )
})
